"use client";
import styles from "@/src/component/blog/blog-detail.module.scss";
import "./blog-detail.scss";
import "./blog-search.scss";
import ImageAntdCommon from "@/src/component/image/image-antd";
import Link from "next/link";
import { useEffect, useState } from "react";
import Image from "next/image";
import { AutoComplete, Input } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import _ from "lodash";
import {
  getBlogNew,
  searchBlogPost,
  getBlogPopular,
} from "@/src/app/api/blog/service";
import defaultImage from "@/public/image/default-image-square.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Scrollbar } from "swiper/modules";
import DirectionsForUseModal from "../coupon/directions-for-use";
import bannerEventFreedom from "@/public/image/nhakhoahub-chao-mung-dai-le-30-4-1-5.webp";
import NProgress from "nprogress";
import { useRouter } from "next/navigation";
import iconSearch from "@/public/icon/icon-search-blog.svg";
import { useMediaQuery } from "react-responsive";
import BookingForm from "./booking-form";

export default function ShowBlogSuggest({ data, hasForm = true }) {
  const router = useRouter();
  const [optionsName, setOptionsName] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataSuggest, setDataSuggest] = useState();
  const [showDirectionForUse, setShowDirectionForUse] = useState(false);
  const [paramName, setParamName] = useState("");

  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    const fetch = async () => {
      try {
        const limit = 5;
        const res = await Promise.all([
          getBlogNew(limit),
          getBlogPopular(limit),
        ]);
        setDataSuggest(
          {
            listBlogNew: res[0].data?.result,
            listBlogPopular: res[1].data?.result,
          } || null
        );
      } catch (error) {
        console.log(error);
      }
    };
    fetch();
  }, []);

  useEffect(() => {
    return () => {
      const scriptToRemove = document.getElementById("reCaptcha_script");
      if (scriptToRemove) {
        document.body.removeChild(scriptToRemove);
      }
    };
  }, []);

  const onSearchName = (searchText) => {
    setParamName(searchText);
    debounceOnChangeInput(searchText);
  };
  const debounceOnChangeInput = _.debounce((event) => {
    requestSearchName(event);
  }, 300);

  function htmlToText(htmlString) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;
    return tempElement.textContent || tempElement.innerText || "";
  }
  const requestSearchName = async (searchText) => {
    // if (abortController) {
    //   abortController.abort();
    // }

    // abortController = new AbortController();
    // const signal = abortController.signal;
    if (searchText) {
      const params = {
        searchText: searchText,
        current: 1,
        pageSize: 20,
      };
      setLoading(true);
      const result = await searchBlogPost(params);
      const newOption = result?.data?.result?.map((item) => {
        return {
          value: htmlToText(item.title),
          key: item.title,
          label: (
            <Link href={`/blog/${item.slug}`}>
              <div className="item-result-blog">
                <Image
                  src={item.thumbnail ? item.thumbnail : defaultImage}
                  className={"logo-on-search-blog"}
                  height={30}
                  width={30}
                  alt="Blog image"
                />
                <div className="wp-text">
                  <div
                    dangerouslySetInnerHTML={{ __html: item.title }}
                    className="title-blog"
                  ></div>
                  {/* <p className="title-blog">{item.title}</p> */}
                  {item.desc && <p className="desc-blog">{item.desc}</p>}
                </div>
              </div>
            </Link>
          ),
        };
      });
      setOptionsName([...(newOption || [])]);
      setLoading(false);
    }
  };
  const onSeachChange = async (event) => {
    if (event?.key === "Enter") {
      onSearchRedirect(event.target.value);
    }
  };

  const onSearchRedirect = (searchText) => {
    const newParams = {
      searchText: searchText,
      current: 1,
      pageSize: 10,
    };
    const newParamsUrl = new URLSearchParams(newParams).toString();
    NProgress.start();
    router.push(`/blog/tim-kiem?${newParamsUrl}`);
  };
  return (
    <>
      {/* {dataSuggest && ( */}
      <div className={styles.wpBlogSuggest}>
        <div className={styles.wpBlogSearch}>
          <AutoComplete
            options={optionsName}
            // placeholder="Tìm kiếm bài viết"
            className="wrapper-input-search-blog"
            id="wrapper-input-search-blog-id"
            popupClassName="popup-search-blog"
            onSearch={onSearchName}
            labelInValue={true}
            filterOption={false}
            notFoundContent={paramName ? "Không có bài viết" : null}
            // onBlur={() => {
            //   setOptionsName([]);
            // }}
            dropdownAlign={{
              points: ["tl", "bl"], // align dropdown bottom-left to top-left of input element
              offset: [0, -4], // align offset
              overflow: {
                adjustX: 0,
                adjustY: 0, // do not auto flip in y-axis
              },
            }}
            onKeyDown={onSeachChange}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
          >
            <Input.Search
              size="large"
              placeholder="Tìm kiếm bài viết"
              enterButton={
                <>
                  {loading ? (
                    <LoadingOutlined
                      style={{ color: "black", marginRight: "8px" }}
                      className="search-blog-loading"
                    />
                  ) : (
                    <Image
                      src={iconSearch}
                      alt="iconSearch"
                      className="icon-search-img"
                      onClick={() => onSearchRedirect(paramName)}
                    />
                  )}
                </>
              }
            />
          </AutoComplete>
        </div>
        <Swiper
          modules={[Pagination, Scrollbar, Autoplay]}
          spaceBetween={100}
          loop={true}
          slidesPerView={1}
          autoplay={{ delay: 3000 }}
          pagination={{ clickable: true }}
          className="wp-blog-voucher"
        >
          {/* <SwiperSlide>
              <Image
                src={banner}
                alt="promotion"
                className={styles.imagePoster}
                onClick={() => setShowDirectionForUse(true)}
              />
            </SwiperSlide> */}
          {/* <SwiperSlide>
              <Image
                src={tartar}
                alt="tartar"
                className={styles.imagePoster}
                onClick={() =>
                  window.open(
                    "https://nhakhoahub.vn/blog/vui-trung-thu-nhakhoahub-tang-uu-dai",
                    "_blank"
                  )
                }
              />
            </SwiperSlide> */}
        </Swiper>
        <div className={styles.wpBlogNew}>
          <p className={styles.headTitle}> TIN MỚI NHẤT </p>
          {dataSuggest?.listBlogNew?.map((item) => (
            <div key={item.title} className={styles.wpContentCard}>
              <Link className={styles.cardItem} href={"/blog/" + item.slug}>
                <ImageAntdCommon
                  data={item.thumb}
                  className={styles.contentImage}
                  width="100%"
                  height="100%"
                />
                <div
                  className={styles.cardItemTitle}
                  dangerouslySetInnerHTML={{ __html: item.title }}
                ></div>
              </Link>
            </div>
          ))}
        </div>
        <div className={styles.wpBlogNew}>
          <p className={styles.headTitle}> TIN ĐỌC NHIỀU </p>
          {dataSuggest?.listBlogPopular?.map((item) => (
            <div key={item.title} className={styles.wpContentCard}>
              <Link className={styles.cardItem} href={"/blog/" + item.slug}>
                <ImageAntdCommon
                  data={item.thumb}
                  className={styles.contentImage}
                  width="100%"
                  height="100%"
                />
                <div
                  className={styles.cardItemTitle}
                  dangerouslySetInnerHTML={{ __html: item.title }}
                ></div>
              </Link>
            </div>
          ))}
        </div>
        <Link href="">
          <Image
            src={bannerEventFreedom}
            className={styles.bannerFeb2025}
            alt="banner-event-freedom"
          />
        </Link>
        <BookingForm />
        <div className={styles.wpSearchFit}>
          <p className={styles.headTitle}>
            Tìm kiếm nha khoa uy tín phù hợp nhất với bạn!
          </p>
          <Link
            href="/phong-kham"
            className={`${styles.wpInputearch} button-blue`}
          >
            TÌM KIẾM CƠ SỞ GẦN NHẤT
          </Link>
        </div>
      </div>
      {/* )} */}
      <DirectionsForUseModal
        isModalOpen={showDirectionForUse}
        setIsModalOpen={setShowDirectionForUse}
        type_page={"BLOG"}
      />
    </>
  );
}
